import { render, staticRenderFns } from "./FormControlOffice.vue?vue&type=template&id=18cb5f43"
import script from "./FormControlOffice.vue?vue&type=script&lang=js"
export * from "./FormControlOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18cb5f43')) {
      api.createRecord('18cb5f43', component.options)
    } else {
      api.reload('18cb5f43', component.options)
    }
    module.hot.accept("./FormControlOffice.vue?vue&type=template&id=18cb5f43", function () {
      api.rerender('18cb5f43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Form/Control/FormControlOffice.vue"
export default component.exports